import { AssessmentDisplayStatus } from '@equip.health/ui';

import { SurveyResponseStatus } from '~/lib/constants/survey/SurveyResponseStatus';

export const SurveyResponseStatusToDisplayStatusMap: Record<
  SurveyResponseStatus,
  AssessmentDisplayStatus
> = {
  [SurveyResponseStatus.DONE]: AssessmentDisplayStatus.COMPLETE,
  [SurveyResponseStatus.IN_PROGRESS]: AssessmentDisplayStatus.IN_PROGRESS,
  [SurveyResponseStatus.NEW]: AssessmentDisplayStatus.NEW,
  [SurveyResponseStatus.REQUESTED]: AssessmentDisplayStatus.NEW,
  [SurveyResponseStatus.INCOMPLETE]: AssessmentDisplayStatus.INCOMPLETE,
  [SurveyResponseStatus.VOID]: AssessmentDisplayStatus.INCOMPLETE,
};
